




























































import {defineComponent, PropType} from '@vue/composition-api';
import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default defineComponent({
  name: 'uOttawa1321Lab1Discussion',
  components: {STextarea},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        discussion: null,
        language: 'en',
      },
      rules: [(v: string) => v?.length <= 4000 || 'Max 4000 characters'],
      questions: [
        {
          en: 'Explain your results for all parts of the experiment. Relate your results to the theory relevant to the experiment.',
          fr: "Expliquez vos résultats pour toutes les parties de l'expérience. Reliez vos résultats à la théorie pertinente pour l'expérience.",
        },
      ],
    };
  },
  methods: {
    getQuestionText(question: any): string {
      return this.inputs.language === 'en' ? question.en : question.fr;
    },
  },
});
